import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Categories from "../Menumanagment/Food/Categories";
import Foodandbeveragesadvertise from "./Foodandbeveragesadvertise";
import { useLoader } from "../../../context/LoaderProvider.jsx";

const FoodandbeveragesMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = window.innerWidth <= 768;

    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [posts, setPosts] = useState([]);
    const [activeCategory, setActiveCategory] = useState("Overview");

    // Add this state to track active tab name
    const [activeTabName, setActiveTabName] = useState("Add Items");

    const scrollContainerRef = useRef(null);
    const { showLoader, hideLoader } = useLoader();

    // Function to update active tab name from Categories component
    const handleActiveTabChange = (tabName) => {
        setActiveTabName(tabName);
    };

    // Handle navigation state
    useEffect(() => {
        if (location.state?.activeCategory) {
            setActiveCategory(location.state.activeCategory);
        }
    }, [location]);

    // Auto-select default tab if data available
    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategory("Allitems");
        }
    }, [categories]);

    const handleClick = (category) => {
        setActiveCategory(category);
    };

    // ✅ Fetch dishes with loader
    // Add your fetchDishes function here if needed

    // Scroll animation
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;
        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1;
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0;
                    }
                }
            }, 20);
        };

        startScrolling();
        return () => clearInterval(interval);
    }, [isHovered]);

    return (
        <>
            <div className="container-fluid">
                <div className="row" style={{ marginTop: "40px" }}>
                    {/* Left Column - Scrollable Category List */}
                    <div className="col-lg-2 col-md-2 col-sm-12 col-12 custom-lg-2">
                        <div
                            style={{
                                maxHeight: "600px",
                                position: "fixed",
                                top: "50px",
                                marginTop: "5px",
                                zIndex: 1000,
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}
                        >
                            <div
                                className="category-container"
                                style={{
                                    overflowY: "auto",
                                    height: "540px",
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none",
                                }}
                            >
                                {[].map((category, index) => (
                                    <div
                                        key={index}
                                        className="category-card"
                                        onClick={() => handleClick(category)}
                                        style={{
                                            backgroundColor:
                                                activeCategory === category
                                                    ? "rgb(177 93 198)"
                                                    : "#D9D9D9",
                                            margin: "8px 0",
                                            padding: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            cursor: "pointer",
                                            justifyContent: "center",
                                            borderRadius: "15px",
                                            transition: "0.3s ease-in-out",
                                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                        }}
                                    >
                                        <div
                                            style={{ fontSize: "20px", fontWeight: "bold" }}
                                            className="category-card-body d-flex justify-content-center p-0"
                                        >
                                            {category}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* middle Column */}
                    <div className="col-lg-9 col-md-7 col-sm-12 col-12 custom-lg-10 cartdta-mobile">
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
                                left: "2vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                flexWrap: "wrap",
                            }}
                        >
                            <Link
                                to="/fooddashboard"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                 
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator" style={{ margin: "0 5px" }}> &gt; </span>
                            <Link
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                  
                                }}
                            >
                                Services & Products
                            </Link>
                            <span className="separator" style={{ margin: "0 5px" }}> &gt; </span>
                            <span style={{
                                color: "purple",
                                fontWeight: "bold",
                               
                            }}>
                                {activeTabName}
                            </span>
                        </p>

                        <div style={{ marginTop: "94px", borderRadius: "8px" }} className="menu-tablee">
                            {activeCategory === "Overview" && (
                                <div>
                                    {/* Pass the callback function to Categories */}
                                    <Categories onActiveTabChange={handleActiveTabChange} />
                                </div>
                            )}
                        </div>
                    </div>
                    {/* right Column */}
                    {/* <div className="col-lg-2  right-column" style={{ display: window.innerWidth < 768 ? "none" : "block" }}>
                        <Foodandbeveragesadvertise />
                    </div> */}
                </div>
            </div>
            <style>
                {`
  /* Custom breakpoint for 950px to 1050px */
  @media (min-width: 950px) and (max-width: 1350px) {
    .custom-lg-2 {
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
    
    .custom-lg-10 {
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
    }
    
    .right-column {
      display: none !important;
    }
          .menu-tablee{
          width:75vw;
          }
  }
`}
            </style>
        </>
    );
};

export default FoodandbeveragesMenu;